export const state = {
  interviewScripts: [],
  isLoading: false,
  totalRecords: 0,
  interviewScriptPerPage: 10000,
  activePage: 1
}
